module.exports = __webpack_public_path__ + "img/wode.33dad6ae.png";